import React from 'react';
import './styles.less';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { FormSelectField } from '../../../../../../../semantic-ui/components/form-select-field';
import { FormInputField } from '../../../../../../../semantic-ui/components/form-input-field';
import { FormTextAreaField } from '../../../../../../../semantic-ui/components/form-textarea-field';
import { FormCheckboxField } from '../../../../../../../semantic-ui/components/form-checkbox-field';
import { CustomRequiredComponent } from '../../../../../../../semantic-ui/components/custom-required';
import { normalizePhone } from '../../../../utils';
import { FormDoublePhoneField } from '../../../../../../../semantic-ui/components/form-double-phone-field';
import { CarFleetField } from './components/CarFleetField/index';

export const CompanyFormView = ({
	isOptionsListLoading,
	deliveryMethods,
	carTypes,
	tonnages,
	temperatureModes,
	carFleetRows,
	onAddCarTypeButtonClick,
	onRemoveCarRow,
	handleChange,
}) => {
	return (
		<div className="dictionary-about-form">
			{/* Основная информация о компании */}
			<section className="dictionary-about-form__section">
				<div className="dictionary-about-form__row">
					<span className="dictionary-about-form__text">О компании</span>
					<div className="dictionary-about-form__container">
						<Field
							name="description"
							type="text"
							component={FormTextAreaField}
							autoComplete="off"
							placeholder="Укажите информацию о компании"
							width="100%"
							resize="vertical"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<span className="dictionary-about-form__text">Сайт компании</span>
					<div className="dictionary-about-form__container">
						<Field
							name="website"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите ссылку на сайт компании"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Способы доставки
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<Field
							name="delivery_methods"
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите способы доставки"
							options={deliveryMethods}
							loading={isOptionsListLoading.deliveryMethods}
							disabled={isOptionsListLoading.deliveryMethods}
							noResultsMessage="Способ доставки не найден"
							search
							multiple
							isWithoutSelectOnBlur
						/>
					</div>
				</div>
			</section>

			{/* Автопарк - используем новый компонент */}

			<div className="dictionary-about-form__cars_section">
				<div className="dictionary-about-form__text_transport">
					Автопарк <CustomRequiredComponent />
				</div>
				<FieldArray
					name="transports"
					component={CarFleetField}
					carFleetRows={carFleetRows}
					handleFieldChange={handleChange}
					carTypes={carTypes}
					tonnages={tonnages}
					isOptionsListLoading={isOptionsListLoading}
					onAddCarTypeButtonClick={onAddCarTypeButtonClick}
					onRemoveCarRow={onRemoveCarRow}
					isWithoutErrorText
				/>
			</div>

			<div className="dictionary-about-form__row">
				<span className="dictionary-about-form__text">Температурные режимы</span>
				<div className="dictionary-about-form__container">
					<Field
						name="modes"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						placeholder="Выберите температурные режимы"
						options={temperatureModes}
						loading={isOptionsListLoading.temperatureModes}
						disabled={isOptionsListLoading.temperatureModes}
						noResultsMessage="Температурный режим не найден"
						search
						multiple
						isWithoutSelectOnBlur
					/>
				</div>
			</div>

			<div className="dictionary-about-form__row">
				<span className="dictionary-about-form__text">Есть валидированный транспорт</span>
				<div className="dictionary-about-form__container">
					<Field name="has_validated_transport" component={FormCheckboxField} toggle type="checkbox" />
				</div>
			</div>

			<div className="dictionary-about-form__row">
				<span className="dictionary-about-form__text">Наличие СМК</span>
				<div className="dictionary-about-form__container">
					<Field name="has_qms" component={FormCheckboxField} toggle type="checkbox" />
				</div>
			</div>

			{/* Контактное лицо */}
			<section className="dictionary-about-form__section">
				<div className="dictionary-about-form__header-text">Контактное лицо</div>
				<div className="dictionary-about-form__subtitle">Укажите данные контактного лица для связи</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Должность
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<Field
							name="contact.post"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите должность"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Фамилия
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<Field
							name="contact.last_name"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите фамилию"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Имя
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<Field
							name="contact.first_name"
							type="text"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите имя"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Почта
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<Field
							name="contact.email"
							type="email"
							component={FormInputField}
							autoComplete="off"
							placeholder="Укажите адрес электронной почты"
						/>
					</div>
				</div>

				<div className="dictionary-about-form__row">
					<div className="dictionary-about-form__text">
						Телефон
						<CustomRequiredComponent />
					</div>
					<div className="dictionary-about-form__container">
						<FormDoublePhoneField
							mainFieldName="contact.phone"
							mainPlaceholder="+7 (___) ___-__-__"
							additionalFieldName="contact.extension"
							mainNormalize={normalizePhone}
							additionalPlaceholder="Добавочный"
						/>
					</div>
				</div>
			</section>
		</div>
	);
};

CompanyFormView.propTypes = {
	isOptionsListLoading: PropTypes.shape({
		deliveryMethods: PropTypes.bool.isRequired,
		carTypes: PropTypes.bool.isRequired,
		tonnages: PropTypes.bool.isRequired,
		temperatureModes: PropTypes.bool.isRequired,
	}).isRequired,
	handleChange: PropTypes.func.isRequired,
	deliveryMethods: PropTypes.array,
	carTypes: PropTypes.array,
	tonnages: PropTypes.array,
	temperatureModes: PropTypes.array,
	carFleetRows: PropTypes.array.isRequired,
	onAddCarTypeButtonClick: PropTypes.func.isRequired,
	onRemoveCarRow: PropTypes.func.isRequired,
};
